import { elementQueries } from './AwsUi';
var StickyElements = /** @class */ (function () {
    function StickyElements() {
        this.elements = [];
    }
    // Registers a `node` that represents a sticky element.
    // The `callback` will be called when other sticky elements on the page
    // announce that sticky positions need to be updated.
    StickyElements.prototype.register = function (node, callback) {
        this.elements.push({ node: node, callback: callback });
    };
    // Removes the given `node` and `callback` from the registry of sticky elements.
    StickyElements.prototype.unregister = function (node, callback) {
        var toRemove = [];
        // Find all occurences of the node/callback pair.
        // This is necessary because it can happen that elements are registered but
        // not properly unregistered.
        this.elements.forEach(function (element, index) {
            if (element.node === node && element.callback === callback) {
                toRemove.push(index);
            }
        });
        while (toRemove.length > 0) {
            this.elements.splice(toRemove.pop(), 1);
        }
    };
    // Notify other sticky elements that their positions need to be updated.
    StickyElements.prototype.notify = function (sourceNode) {
        var _this = this;
        elementQueries.requestAnimationFrame(function () {
            _this.elements.forEach(function (_a) {
                var node = _a.node, callback = _a.callback;
                if (node !== sourceNode) {
                    callback();
                }
            });
        });
    };
    return StickyElements;
}());
var stickyElements = new StickyElements();
export default stickyElements;
export { StickyElements };
//# sourceMappingURL=sticky-elements.js.map